module.exports = __webpack_public_path__ + "static/media/more.f6ff807f.svg";